module.exports = __webpack_public_path__ + "img/mailang-bg.f0c12e9b.jpg";